import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		pictureData: '', //首页数据
		en_cn: '', //中英文
		fat_bool: '', //判断是否为父列表和子列表
		dayNightMode: '', //夜间模式
		isChangeMode: false, // 是否手动切换模式
		homePage: 1,
		homeBz: '', // 首页标志
		projectsContBz: '', // 项目详情页标志
	},
	mutations: {
		changeDayNightMode(state, data) {
			state.dayNightMode = data;
		},
		changeMode(state, data) {
			state.isChangeMode = data;
		},
	},
	actions: {},
	modules: {},
});
